import { useEffect, useState, useCallback } from "react";
import ProductsTable from "./ProductsTable";
import Spinner from "../../components/Spinner";
import {
  fetchProducts,
  approveProduct,
  rejectProduct,
} from "./adminProductsAPI";
import { useAuth } from "../../contexts/AuthContext";

export default function AdminProducts() {
  const [products, setProducts] = useState([]);
  const [pageInfo, setPageInfo] = useState({
    number: 0,
    size: 20,
    totalPages: 0,
  });
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const { auth } = useAuth();

  const loadProducts = useCallback(
    async (page = 0, size = pageInfo.size) => {
      try {
        setLoading(true);
        const data = await fetchProducts(page, size);
        setProducts(data.content || []);
        setPageInfo({
          number: data.pageNumber,
          size: data.pageSize,
          totalPages: data.totalPages,
        });
        setError("");
      } catch {
        setError("Failed to load products");
      } finally {
        setLoading(false);
      }
    },
    [pageInfo.size],
  );

  useEffect(() => {
    loadProducts(0);
  }, [loadProducts]);

  const handleApprove = async (id) => {
    try {
      await approveProduct(id, auth.userId);
      loadProducts(pageInfo.number);
    } catch (err) {
      console.error("Failed to approve:", err);
    }
  };

  const handleReject = async (id, reason) => {
    try {
      await rejectProduct(id, reason, auth.userId);
      loadProducts(pageInfo.number);
    } catch (err) {
      console.error("Failed to reject:", err);
    }
  };

  if (loading) {
    return <Spinner text="Loading products..." />;
  }

  if (error) return <p className="text-danger">{error}</p>;

  return (
    <div className="container mt-4">
      <h2>Product Moderation</h2>

      <ProductsTable
        products={products}
        onApprove={handleApprove}
        onReject={handleReject}
      />

      {/* Pagination */}
      <div className="d-flex justify-content-between align-items-center mt-4">
        <button
          className="btn btn-outline-primary"
          disabled={pageInfo.number === 0 || loading}
          onClick={() => loadProducts(pageInfo.number - 1)}
        >
          ← Previous
        </button>

        <span>
          Page {pageInfo.number + 1} of {pageInfo.totalPages}
        </span>

        <button
          className="btn btn-outline-primary"
          disabled={pageInfo.number + 1 >= pageInfo.totalPages || loading}
          onClick={() => loadProducts(pageInfo.number + 1)}
        >
          Next →
        </button>
      </div>
    </div>
  );
}
